import forEach from "./customForEach";
import postData from "./postData";
import $ from "jquery";

function initJsModalSubmitOrder() {
    // send form
    forEach(
        document.querySelectorAll(".js-modal-submit-order"),
        function (index, form) {
            const form_button = form.querySelector(".js-submit-form");
            let form_button_t = "";
            if (form_button) {
                form_button_t = form_button.innerHTML;
            }
            form.addEventListener("submit", (event) => {
                event.preventDefault();
                if (form_button) {
                    form_button.innerHTML = "Отправка...";
                    form_button.disabled = true;
                }

                let data_form = form.querySelector(".form-data__input");
                let data_result = form.querySelector(".form-data__result");
                let msg_el = form.querySelector(".message");

                let request = {
                    name: form.querySelector("[name=name]").value,
                    phone: form.querySelector("[name=phone]").value,
                    customer_text: "",
                };

                let el = form.querySelector("[name=call_time]");
                if (el) {
                    request.call_time = el.value;
                }

                el = form.querySelector("[name=provider_name]");
                if (el) {
                    request.provider_name = el.value;
                }

                el = form.querySelector(".popap-accordion_title .name span");
                if (el) {
                    request.tariff_name = el.innerText;
                }

                forEach(
                    document.querySelectorAll("[data-name]:checked"),
                    function (i, checkbox) {
                        request.customer_text += checkbox.dataset.name + "\n";
                    }
                );

                postData(form.getAttribute("action"), request)
                    .then((data) => {
                        if (data.errors) {
                            let errorsMessages = "";

                            const errors = Object.values(data.errors);
                            errorsMessages = errors.flat().join("<br />");

                            msg_el.innerHTML =
                                `<span class="error">` +
                                errorsMessages +
                                `</span>`;
                            if (data_form.parentElement.classList.contains("free-consultation__form")) {
                                msg_el.style.display = "flex";
                            }
                            form_button.innerHTML = form_button_t;
                        } else {
                            if (data_form.parentElement.classList.contains("free-consultation__form")) {
                                //вывод попапа для блока консультации
                                const consultModal = document.getElementById('free-consultation-modal');
                                consultModal.classList.add('active');
                                msg_el.style.display = "none";
                            } else {
                                if (data_form || data_result) {
                                    data_form.classList.add("hide");
                                    data_result.classList.remove("hide");
                                }
                            }
                            form.querySelectorAll('.field').forEach(input => input.value = '');
                            msg_el.innerHTML = `<span class="success"></span>`;
                            form_button.innerHTML = form_button_t;
                        }
                    })
                    .catch(function (error) {
                        msg_el.innerHTML = `<span class="error">Не удалось отправить заявку, попробуйте позже.</span>`;

                        if (data_form.parentElement.classList.contains("free-consultation__form")) {
                            msg_el.style.display = "flex";
                        }
                        form_button.innerHTML = form_button_t;
                    })
                    .finally(function() {
                        form_button.disabled = false;
                });
            });
        }
    );
}

export default initJsModalSubmitOrder;
